import {DomainObject} from 'shared/store';
import {computed, observable} from 'mobx';

class AiScreenerPrompt extends DomainObject {
  @observable text;
  @observable totalCandidateCount;
  @observable completedCandidateCount;
  @observable paused;

  @computed get inProgress() {
    return this.completedCandidateCount !== this.totalCandidateCount && !this.paused;
  }

  @computed get progress() {
    return `${this.completedCandidateCount}/${this.totalCandidateCount}`;
  }
}

export default AiScreenerPrompt;
